import { render } from "./RecentClients.vue?vue&type=template&id=1983a5a1&ts=true"
import script from "./RecentClients.vue?vue&type=script&lang=ts"
export * from "./RecentClients.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__